/** @file Splits a slot key `<drawable>/<entry>/<tile>` back into its parts; null when malformed. */

/** Parsed slot key, or null unless it has exactly three `/`-separated parts with non-negative integer indices. */
export function parseSlotKey(key: string): { drawable: string; entry: number; tile: number } | null {
  const m = /^([^/]+)\/(\d+)\/(\d+)$/.exec(key);
  if (m === null) return null;
  return { drawable: m[1] ?? '', entry: Number(m[2]), tile: Number(m[3]) };
}
